// PartnerInactiveBillDetailsContainer.jsx
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate, useParams } from "react-router-dom";
import toastr from "react-redux-toastr";
import PartnerBillSummaryComponent from "./component";

const PartnerInactiveBillDetailsContainer = ({ getDataFromAPI }) => {
  const navigate = useNavigate();
  const { franchiseeId, billId } = useParams();
  const [billData, setBillData] = useState(null);
  const [payoutBillData, setPayoutBillData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [getFranchiseeId, setGetFranchiseeId] = useState("");
  const [chargeSummary, setChargeSummary] = useState(null); // For payout deduction summary
  const [allCharges, setAllCharges] = useState(null); // For all charges list from fetchCharges API
  const [chargesLoading, setChargesLoading] = useState(false);

  const handlePostBill = () => {
    navigate(`/home/configuration/partner/bills/post-bills/${getFranchiseeId}`);
  };

  const handleMiscCharge = () => {
    navigate(`/home/configuration/partner/bills/miscellaneous-charge`, {
      state: {
        franchiseeId: billData?.franchiseeId,
        partnerName: billData?.name,
      },
    });
  };

  // Fetch all charges when franchiseeId is available
  useEffect(() => {
    const id = franchiseeId || getFranchiseeId;
    if (id) {
      fetchAllCharges(id);
    }
  }, [franchiseeId, getFranchiseeId]);

  const fetchAllCharges = (franchiseeId) => {
    if (!franchiseeId) {
      console.warn("No franchiseeId provided to fetch charges");
      return;
    }

    setChargesLoading(true);
    getDataFromAPI(
      `/dashboard/api/v2/admin/platform/beneficiary/franchisee/${franchiseeId}/charge`,
      'GET',
      undefined,
      (response) => {
        console.log("All charges response:", response);
        setAllCharges(response);
        setChargesLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error("Error", err.message || "Failed to load charges");
        setChargesLoading(false);
      }
    );
  };

  const fetchChargeBillSummary = (payoutId) => {
    if (!payoutId) {
      toastr.warning("Warning", "No payout ID available");
      return;
    }

    setLoading(true);
    getDataFromAPI(
      `/partner/api/v3/acc/payout/${payoutId}/deduction`,
      'GET',
      undefined,
      (response) => {
        console.log("Charge summary response:", response);
        setChargeSummary(response);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error(err.message || "Error", "Failed to load charge summary");
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchBillData();
    fetchPayoutBillData();
  }, [billId]);

  const fetchBillData = () => {
    setLoading(true);
    getDataFromAPI(
      `/partner/api/v3/acc/bills/${billId}/charges`,
      "GET",
      undefined,
      (response) => {
        console.log("Bill data response:", response);
        setBillData(response);
        setGetFranchiseeId(response.franchiseeId);
        if (response.franchiseeId) {
          fetchAllCharges(response.franchiseeId);
        }
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching bill:", err.message);
        toastr.error("Error", err.message);
        setLoading(false);
      }
    );
  };

  const fetchPayoutBillData = () => {
    setLoading(true);
    getDataFromAPI(
      `/partner/api/v3/acc/bill/${billId}/payout`,
      "GET",
      undefined,
      (response) => {
        console.log("payout response", response);
        setPayoutBillData(response);
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching bill:", err.message);
        toastr.error("Error", err.message);
        setLoading(false);
      }
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleGoBack = () => navigate(-1);

  return (
    <PartnerBillSummaryComponent
      loading={loading}
      chargesLoading={chargesLoading}
      billData={billData}
      payoutBillData={payoutBillData}
      onGoBack={handleGoBack}
      handleMiscCharge={handleMiscCharge}
      handlePostBill={handlePostBill}
      fetchChargeBillSummary={fetchChargeBillSummary}
      chargeSummary={chargeSummary}
      allCharges={allCharges}
    />
  );
};

export default connect(null, { getDataFromAPI })(PartnerInactiveBillDetailsContainer);